import { Helmet } from "react-helmet";
import { useTranslation, Trans } from "react-i18next";
import { Link } from "react-router-dom";
import SiteRightContent from "../../components/SiteRightContent";
import LogoWithHomeLink from "../../components/LogoWithHomeLink";
import SitePageLeftHeading from "../../components/SitePageLeftHeading";

export default function Home() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('pages.home.title')}</title>
      </Helmet>

      <div className="flex flex-col flex-1 w-full lg:w-1/2">
      <LogoWithHomeLink />
        <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
          <div>
            <SitePageLeftHeading
              title={t('pages.home.page_title')}
              description={
                <Trans i18nKey="pages.home.description">
                  <strong className="text-gray-800 dark:text-white/90">DPS Digital KYC system.</strong>
                </Trans>
              }
            />
            <div>
              <div className="space-y-5">
                <Link
                  to="/language"
                  className="flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white transition rounded-lg bg-brand-500 shadow-theme-xs hover:bg-brand-600"
                >
                  {t("pages.home.button.register")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SiteRightContent />
    </>
  );
}
